import classnames from 'classnames/bind'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import StarRatings from '~/components/UI/StarRatings'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface Review {
  id?: string
  name?: string
  title?: string
  body?: string
  productId?: string
  rating?: number
  verified?: boolean
  date?: string
  reviewer?: ReviewReviewer
}

export interface ReviewReviewer {
  name?: string
}

export interface ProductReviewProps extends Review {
  className?: string
}

function ProductReview({
  className,
  title,
  body,
  rating,
  verified,
  date,
  reviewer,
}: ProductReviewProps) {
  const dateStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12PrimaryReg,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Gray1ToBlack,
  })
  const titleStyle = useStyle({
    textPreset: GlobalTextPreset.Title12Primary,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  const nameStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12PrimaryReg,
    textStyling: GlobalTextStyling.UpperCase,
    color: GlobalThemeColors.Black,
  })

  const bodyStyle = useStyle({
    textPreset: GlobalTextPreset.Text12Secondary,
    color: GlobalThemeColors.Gray1ToBlack,
  })

  return (
    <div className={cx(css.ProductReview, className)}>
      <div className={cx(css.top)}>
        {rating && (
          <StarRatings
            className={cx(css.ratings)}
            itemClassName={cx(css.star)}
            ratings={rating}
          />
        )}
        {title && <h4 className={cx(css.title, titleStyle)}>{title}</h4>}
      </div>
      {body && (
        <div className={cx(css.content)}>
          <p className={cx(css.body, bodyStyle)}>{body}</p>
        </div>
      )}
      <div className={cx(css.bottom)}>
        {reviewer?.name && (
          <span className={cx(css.name, nameStyle)}>{reviewer?.name}</span>
        )}

        {date && <span className={cx(css.date, dateStyle)}>{date}</span>}
      </div>
    </div>
  )
}

export default ProductReview
